import {displayColor} from './displayColor.js';
// Vivid, saturated tier colors for pass visuals. The base design tokens
// (--cyan #7faec8, --green #82b58a) are intentionally muted for a calm UI, but
// they read as gray on the dark Tonight strip / plot. These brighter hues are
// used specifically for pass arcs, dots, and timeline chips so passes are easy
// to tell apart and the selected one pops. Index = visibility_tier (0..3).
export const TIER_COLORS = ['#8b94a3', '#54c4ec', '#57d08a', '#ffc861'];
export const TIER_LABELS = ['Not visible', 'Naked-eye visible', 'Worth going outside', 'Photograph this'];
export const tierColor = t => displayColor(TIER_COLORS[t] ?? TIER_COLORS[0]);

// Forward-looking window for "tonight" pass discovery, in hours. A full day so
// querying in the early morning still surfaces the coming night's passes (a 12h
// window at 6 AM is all daylight). Single source of truth: every pass-tonight
// fetch and client-side window filter derives from this.
export const PASS_WINDOW_HOURS = 24;

// Punchy one-word rating shown on the timeline (mock vocabulary), derived from
// the existing visibility_tier + magnitude, NOT a new scoring model:
//   tier 3 (high/long/bright)        → EXCELLENT
//   tier 2 (worth going outside)     → GOOD
//   tier 1 (naked-eye, but marginal) → CAMERA if faint (mag > 2.5), else MARGINAL
//   tier 0 (below the bar)           → SKIP
// "CAMERA" = visible to a camera/optics but tough for the naked eye.
export function ratingWord(pass) {
  const tier = pass?.visibility_tier || 0;
  if (tier >= 3) return 'EXCELLENT';
  if (tier === 2) return 'GOOD';
  if (tier === 1) return (pass?.approx_magnitude != null && pass.approx_magnitude > 2.5) ? 'CAMERA' : 'MARGINAL';
  return 'SKIP';
}

